import { render } from "./DeliveryClientOrdersDetails.vue?vue&type=template&id=1baf74c7&scoped=true"
import script from "./DeliveryClientOrdersDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryClientOrdersDetails.vue?vue&type=script&lang=js"

import "./DeliveryClientOrdersDetails.vue?vue&type=style&index=0&id=1baf74c7&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baf74c7"]])

export default __exports__